import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../main/Apicall';
import "../css/others/template.css";
import { ClientSelection } from "../Interfaces/Interface"
const ClientSelectionComponent: React.FC = () => {
    const [clients, setClients] = useState<ClientSelection[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchClients = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const data = await apiCall('get', 'api/clients/names/all');
                setClients(data);
            } catch (err) {
                console.error('Error fetching clients:', err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchClients();
    }, []);
    const handleClientSelect = (clientId: string, clientName: string) => { navigate(`/templatesdetails/${clientId}`, { state: { clientName } }); };
    return (
        <div className="table-details">
            <h2>Select Client</h2>
            {isLoading ? (
                <div className="error-message">{error}</div>
            ) : (
                <>
                    <select onChange={(e) => { const clientId = e.target.value; const clientName = e.target.options[e.target.selectedIndex].text; handleClientSelect(clientId, clientName); }} disabled={isLoading}>
                        <option value="">-- Select a Client --</option>
                        {clients.map(client => (
                            <option key={client.clientId} value={client.clientId}>
                                {client.clientName}
                            </option>
                        ))}
                    </select>
                    <button className="back-btn2" onClick={() => navigate(-1)}>Back</button>
                </>
            )}
        </div>
    );
};
export default ClientSelectionComponent;